import React, { Component } from 'react';
import { renderRoutes } from 'react-router-config';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Nav from './nav';
import TopBar from './topbar';
import Alert from './alert';
import Footer from './footer';
import Loader from './loader';

class LayoutStandard extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { user, loading, routes, toggleNav, userBlocked, userVerified, emailVerified, tradingDisabled, navOpen } = this.props;
    return (
      <div className="page-wrapper standard-page">
        <div className="content-wrapper">
          <Nav navOpen={navOpen} toggleNav={toggleNav} />
          <div className="main-content">
            { userBlocked ? (
              <div className="alert-container vt-banner">
                <div className="alert">
                  Your account has been temporarily blocked for security reasons. Please contact support to discuss.
                </div>
              </div>
            ) : (
              null
            )}
            { ((!userVerified || !emailVerified || tradingDisabled) && !loading) && (
              <Alert
                verified={userVerified}
                email={emailVerified}
                tradingDisabled={tradingDisabled}
              />
            )}
            <TopBar toggleNav={toggleNav} />

            { loading ? (
              <div className="center-loader">
                <Loader logo />
              </div>
            ) : (
              renderRoutes(routes)
            )}
            <Footer />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  loading: state.user.loading,
});

export default withRouter(connect(mapStateToProps)(LayoutStandard));
